import script from "./TicketStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketStatus.vue?vue&type=script&setup=true&lang=js"

import "./TicketStatus.vue?vue&type=style&index=0&id=829e0378&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-829e0378"]])

export default __exports__